<template>
    <div class="container wallet-page">
        <div v-if="logoutSplash" class="logout-splash">
          <span>{{ logoutMessage }}</span>
        </div>
        
        <div class="p-1">
            <div class="row mt-3">
                <span class="edit-profile wallet-back" @click="backProfile()">
                    <img src="../assets/arrow-back.png" alt="" width="25px"> Profile
                </span>
            </div>
            <div class="wallet-hero">
                <div>
                    <p class="wallet-kicker mb-1">Wallet overview</p>
                    <h4 class="wallet-title mb-1">My Transactions</h4>
                    <p class="wallet-copy mb-0">Track deposits, withdrawals, and token activity in one clean view.</p>
                </div>
                <div class="wallet-summary">
                    <div class="wallet-balance">
                        <span class="wallet-balance-label">Wallet balance</span>
                        <div class="wallet-balance-value">
                            {{ formatToken(walletBalance) }}{{ token_label }}
                            <button class="wallet-toggle" @click="convertRate" style="cursor: pointer;">
                                <i class="fa fa-exchange-alt"></i>
                            </button>
                        </div>
                        <span v-if="showNaria" class="wallet-naira">{{ formatAmount(nairaBalance) }}</span>
                    </div>
                    <div class="wallet-actions">
                        <button class="wallet-btn wallet-btn-secondary" data-bs-toggle="modal" data-bs-target="#fundWalletModal">
                            <i class="fa fa-plus"></i> Buy Token
                        </button>
                        <button class="wallet-btn wallet-btn-primary" @click="withdrawAmount()">
                            <i class="fa fa-credit-card"></i> Withdraw
                        </button>
                    </div>
                </div>
            </div>
            <div class="card wallet-card mt-3">
                <div class="card-header wallet-card-header">
                    <h6 class="mb-0">
                        <i class="fa fa-exchange-alt"></i> Transaction History
                    </h6>
                </div>
                <div class="card-body wallet-table-shell table-responsive">
                <table class="table table-striped table-hover align-middle mb-0 wallet-table" style="font-size: 12px;">
                    <thead>
                    <tr>
                        <th>Sn</th>
                        <th>Token</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Transaction date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in wallets" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ formatToken(item.dayruns_token) }}{{ token_label }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.reference }}</td>
                        <td>{{ item.status }}</td>
                        <td>{{ new Date(item.created_at).toLocaleString() }}</td>
                    </tr>
                    </tbody>
                </table>
                </div>
                <!-- Empty State -->
                <div v-if="wallets.length === 0" class="wallet-empty-state">
                        No record available.
                </div>
            </div>
        </div>

        <!-- Withdraw Modal -->
        <div
        class="modal fade"
        id="withdrawModal"
        tabindex="-1"
        aria-labelledby="withdrawModalLabel"
        aria-hidden="true"
        >
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header wallet-modal-header">
                <h5 class="modal-title" id="withdrawModalLabel">Withdraw Funds</h5>
                <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
                ></button>
            </div>

            <div class="modal-body wallet-modal-body">
                <label class="wallet-form-label">Enter Amount to Withdraw</label>
                <input
                type="number"
                class="form-control mt-2 wallet-input"
                v-model="withdrawAmountValue"
                placeholder="Enter amount"
                />
            </div>

            <div class="modal-footer">
                <button
                type="button"
                class="btn btn-secondary wallet-modal-btn"
                data-bs-dismiss="modal"
                >
                Cancel
                </button>

                <button
                type="button"
                class="btn btn-success wallet-modal-btn"
                @click="confirmWithdraw"
                >
                Withdraw
                </button>
            </div>
            </div>
        </div>
        </div>

         <!-- Purchase Token Modal -->
        <div class="modal fade" id="fundWalletModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content rounded-4 shadow-lg wallet-modal">

                <!-- Header -->
                <div class="modal-header bg-primary text-white rounded-top-4 wallet-modal-header">
                <h5 class="modal-title fw-bold">
                    <i class="fa fa-coins me-2"></i> Buy Tokens
                </h5>
                <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>

                <!-- Body -->
                <div class="modal-body wallet-modal-body">

                <p class="text-muted mb-4">
                    Transactions on this platform require tokens. Please select a token package below.
                </p>

                <!-- Token Cards -->
                <div class="row g-3">
                    <div
                    class="col-4 col-md-3"
                    v-for="token in tokens"
                    :key="token.id"
                    >
                    <div class="card border-0 shadow-sm h-80 text-center p-2 token-card">

                        <!-- Token Icon -->
                        <div class="mb-1">
                        <i class="fa fa-coins fa-lg text-warning"></i>
                        </div>

                        <!-- Token Amount -->
                        <h6 class="fw-bold small mb-1 config">
                        {{ formatToken(token.number_of_token) }}{{ token_label }}
                        </h6>

                        <!-- Price -->
                        <h6 class="text-primary fw-bold mb-2 config">
                        {{ formatAmount(token.price) }}
                        </h6>

                        <!-- Buy Button -->
                        <button
                        class="btn btn-success btn-sm w-100"
                        @click="buyToken(token)"
                        >
                        Buy
                        </button>

                    </div>
                    </div>
                </div>

                <!-- Info -->
                <div class="alert alert-info d-flex align-items-center mt-4 wallet-info">
                    <i class="fa fa-info-circle me-2"></i>
                    Once payment is successful, your wallet will be credited within 2 minutes.
                </div>

                </div>

                <!-- Footer -->
                <div class="modal-footer wallet-modal-footer">
                <button class="btn btn-outline-secondary wallet-modal-btn" data-bs-dismiss="modal">
                    Close
                </button>
                </div>

            </div>
            </div>
        </div>

         <!-- Payment Link Generation Modal -->
      <div
        class="modal fade"
        id="paymentLinkModal"
        tabindex="-1"
        aria-hidden="true"
        ref="paymentLinkModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content rounded-4 shadow-lg border-0">
            <div class="modal-body text-center p-5">
              <div class="spinner-border text-primary mb-3" role="status" aria-hidden="true"></div>
              <h5 class="fw-bold mb-2">Generating payment link</h5>
              <p class="text-muted mb-0">
                Please wait while we prepare your payment window.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

</template>
<script>
//import imageCompression from 'browser-image-compression';
import * as bootstrap from 'bootstrap'
import swal from 'sweetalert2';
//import PaystackPop from '@paystack/inline-js';

export default {

    components: {    
    },
    
    data() {
    return {
        pageLoader: false,
       
        logoutSplash: false,
        logoutMessage: "",

        wallets: [],
        walletBalance: 0,
        nairaBalance: 0,
        showNaria: false,
        withdrawAmountValue: "",
        tokens: [],
        fund_amount: 0,
        selected_tokens: 0,
        apikey: '',
        email: '',
        phone: '',
        fullname: '',
        token_label: process.env.VUE_APP_TOKEN_LABEL,
        timer: null,
        reference: null,
        paymentLinkModalInstance: null,
      

        };
    },

async beforeMount(){
    this.userid = this.$route.params.escortid;
    this.user_id = localStorage.getItem("userid"); 
    await this.fetchAllTokens()
    this.email = localStorage.getItem('email');
},

async mounted(){
    await this.getConfigData()
    await this.fetchWalletTransctions(this.userid)
    await this.getWalletbalance(this.userid)
    await this.listMyProfile(this.userid)
    this.reference = Date.now();
    
},

methods: {
    async getConfigData(){
      const response = await fetch('/config.json');
      const configData = await response.json();
      this.apikey = configData.apikey;
    },
    async fetchAllTokens(){
        try{
        const response = await this.$http.get(`/fetch-tokens`,{} )
        this.tokens = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    startPolling() {
        this.timer = setInterval(async () => {
            try {
                 const res = await this.$http.post("/payment-status", {
                      reference: this.reference
                  });

                if (res.data.status === "00") {
                    clearInterval(this.timer);

                    window.location.reload();
                }
            } catch (err) {
                console.error(err);
            }
        }, 3000);
    },

    async listMyProfile(userid){
         try{

            const response = await this.$http.post('/list-profile',{ user_id: userid} )
            this.escort_data = response.data.data[0];
            this.escortid = this.escort_data.escortid
            this.fullname = this.escort_data.name
            this.phone = this.escort_data.phone_number

            }catch (err) {
                console.log(err);
            }
    },
    buyToken(token) {
      this.selected_tokens = token.number_of_token;
      this.fund_amount = token.price;

      // Call payment function
      this.makePayment();
    },
    // makePayment(){
    //     const paystack = new PaystackPop();

    //     paystack.newTransaction({
    //         key: this.apikey,
    //         email: this.email,
    //         amount: Number(this.fund_amount) * 100,

    //         onSuccess: (transaction) => { 
    //             // Payment complete! Reference: transaction.reference 
    //             this.pay(transaction.reference )
    //         },
    //         onCancel: () => {
    //             // user closed popup
    //         }
    //     });
    // },

       async makePayment(){
        try{
          const response = await this.$http.post('/create-order', {
            amount: Number(this.fund_amount),
            planCode: "FBX-EA048B52-266",
            product: "Service Payment",
            name: this.fullname,
            email: this.email,
            phone: this.phone
          });

        if (response.data.success) {
          const paymentLink = response.data.data.paymentLink;

          if (!paymentLink) {
            swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Payment link could not be generated.',
              width: 400
            });
            return;
          }

          this.openPaymentLinkModal();

          setTimeout(() => {
            this.closePaymentLinkModal();
            // window.open(paymentLink, "_blank");
             window.location.href = paymentLink;
          }, 1500);

          this.pay()
        
        return;
        } 
             
        }catch (err) {
          console.log(err);
          alert(err.response ? err.response.data.message : err.message)

      }
    },

      async pay() {
        try{
          await this.$http.post('/pay', {
            user_id: this.user_id,
            email: this.email,
            amount: this.fund_amount,
            token: this.selected_tokens,
            payment_reference: this.reference
          });

          this.startPolling();
             
        }catch (err) {
          console.log(err);
      }

    },

     openPaymentLinkModal() {
      if (!this.paymentLinkModalInstance) {
        this.paymentLinkModalInstance = new bootstrap.Modal(this.$refs.paymentLinkModal, {
          backdrop: 'static',
          keyboard: false
        });
      }

      this.paymentLinkModalInstance.show();
    },

     closePaymentLinkModal() {
      if (this.paymentLinkModalInstance) {
        this.paymentLinkModalInstance.hide();
      }
    },

    convertRate(){
      if(!this.showNaria){
        this.showNaria = true
      }else{
        this.showNaria = false
      }
    },
    backProfile() {
    // Go to previous page
    this.$router.go(-1);
    },
   
    closeModal() {
      this.showUploadWarning = false;
    },
 

    async fetchWalletTransctions(userid){
        try{
        const response = await this.$http.get(`/fetch-allwallet-transactions/${userid}`,{} )
        this.wallets = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async getWalletbalance(userId) {
      try {

       const response = await this.$http.get(`/fetch-wallets-byuser/${userId}`, {},
       {
            headers: { 
                "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
            }
          }
       )
      
        if (response.data.success) {
            this.walletBalance = response.data.data
            this.nairaBalance = response.data.naira
        }
    
        } catch (err) { 
            alert(err.response ? err.response.data.message : err.message)
        }
    },

    withdrawAmount() {
        this.withdrawAmountValue = ""; // clear previous input

        const modal = new bootstrap.Modal(
        document.getElementById("withdrawModal")
        );
        modal.show();
    },

    async confirmWithdraw() {
        try {
        
            if (!this.withdrawAmountValue || this.withdrawAmountValue <= 0) {
                alert("Please enter a valid amount.");
                return;
            }

            // Validate balance
            if (this.withdrawAmountValue > this.walletBalance) {
                alert("You cannot withdraw more than your wallet balance.");
                return;
            }

            const response = await this.$http.post("/withdraw-request", {
                model_id: this.userid,
                amount: this.withdrawAmountValue,
            });

            if (response.data.success) {
                alert(`Withdraw request of ${this.withdrawAmountValue} successful!`);
                window.location.reload()

            } else {
                alert(`Request Failed`);
            }
        } catch (err) {
            console.error(err);
            alert(err.response ? err.response.data.message : err.message)
        }
    },

    formatAmount(value) {
        return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: 'NGN',
        minimumFractionDigits: 0
        }).format(value);
    },

    formatToken(value) {
      const num = Number(value);

      if (!Number.isFinite(num)) {
        return value ?? '0';
      }

      if (num >= 1000000) {
        return '1m';
      }

      if (num >= 1000) {
        const abbreviated = (num / 1000).toFixed(1).replace(/\.0$/, '');
        return `${abbreviated}k`;
      }

      return new Intl.NumberFormat('en-US').format(num);
    },

    async widthdrawFee(amount, truthdare_id) {
        try {
            const response = await this.$http.post("/transfer-wallet", {
                email: this.escort_data.email_address,
                amount: amount,
                user_id: this.userid,
                payment_reference: Date.now(),
                booking_id: truthdare_id
            });

            if (response.data.success) {
                alert(`Transfer of ${amount} successfully!`);
                window.location.reload()

            } else {
            alert(`Failed to transfer ${amount}.`);
            }
        } catch (err) {
            console.error(err);
            alert(`Error occurred while transfering of ${amount}`);
        }
    }

    },

}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');

.wallet-page {
  padding-top: 1rem;
  padding-bottom: 1.5rem;
}

.wallet-hero {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.4rem;
  border: 1px solid rgba(211, 62, 116, 0.12);
  border-radius: 22px;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.12), rgba(10, 7, 15, 0.03));
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.wallet-kicker {
  margin: 0;
  color: #D33E74;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.wallet-title {
  margin: 0;
  color: #ccc;
  font-family: 'DM Sans';
  font-size: 1.6rem;
  font-weight: 800;
}

.wallet-copy {
  max-width: 56ch;
  color: #667085;
  font-size: 0.95rem;
}

.wallet-summary {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  min-width: 320px;
  padding: 1rem 1.1rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.05);
}

.wallet-balance-label {
  display: block;
  color: #667085;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.wallet-balance-value {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #111827;
  font-size: 1.15rem;
  font-weight: 800;
}

.wallet-toggle {
  padding: 0;
  border: 0;
  background: transparent;
  color: #D33E74;
}

.wallet-naira {
  color: #475467;
  font-size: 0.92rem;
  font-weight: 600;
}

.wallet-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.wallet-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.7rem 1rem;
  border: 0;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 700;
  transition: 0.2s ease;
}

.wallet-btn:hover {
  transform: translateY(-1px);
}

.wallet-btn-primary {
  background: #0f172a;
  color: #fff;
}

.wallet-btn-secondary {
  background: linear-gradient(135deg, #D33E74, #bf2f66);
  color: #fff;
}

.wallet-card {
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 20px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.06);
}

.wallet-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
}

.wallet-card-header h6 {
  color: #111827;
  font-family: 'DM Sans';
  font-weight: 800;
}

.wallet-table-shell {
  padding: 0 !important;
}

.wallet-table thead th {
  color: #667085;
  background: #f8fafc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.wallet-table tbody td {
  color: #111827;
  vertical-align: middle;
}

.wallet-table .table > :not(caption) > * > * {
  padding: 0.9rem 0.95rem;
}

.wallet-empty-state {
  padding: 1rem;
  color: #667085;
  font-size: 0.92rem;
  text-align: center;
}

.wallet-modal-header {
  background: linear-gradient(135deg, #D33E74, #bf2f66) !important;
}

.wallet-modal-body {
  background: #fff;
}

.wallet-modal-footer {
  background: #fff;
}

.wallet-modal-btn {
  border-radius: 999px;
}

.wallet-modal {
  border: 0;
}

.wallet-info {
  border: 0;
  border-radius: 16px;
  background: rgba(211, 62, 116, 0.08);
  color: #D33E74;
}

.wallet-form-label {
  display: block;
  margin-bottom: 0.4rem;
  color: #111827;
  font-weight: 700;
}

.wallet-input {
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.12);
}

.wallet-back {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #D33E74;
  font-weight: 700;
  cursor: pointer;
}

.wallet-back img {
  display: block;
}

.token-card {
  transition: 0.3s ease;
  border-radius: 12px;
  h6{
    font-size: 10px;
  }
}

.token-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}
.btn-success{
    background: #D33E74 !important;
    border: 0;
}
/* Simple modal styles */
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  width: 300px;
}

.popup-actions button {
  margin: 5px;
}
.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}
.preview-box {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
}

.preview-video {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent;
  position: absolute;
  z-index: 10;
}
.modal-header{
    background: #D33E74 !important;
    color: #fff;
}
.btn-primary{
    background: #D33E74 !important;
    color: #fff;
    border: 0px;
}
.image-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.account-switch{
    width: 120px;
}
.video-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.img-fluid{
    border-radius: 10px;
    width: 100%;
    aspect-ratio: 4 / 5;
    object-fit: cover;
    border-radius: 10px;
    transition: transform 0.3s ease-in-out; /* Optional for smooth effect */
  }
.likes-followers{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    h4{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        color: #FFFFFF;
    }
}

@media screen and (max-width: 768px) {
.likes-followers{
    margin-top: -10px;
}
}

.image-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.image-preview:hover {
  border-color: #D33E74;
}

.video-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.video-preview:hover {
  border-color: #D33E74;
}

.upload-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.video-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.file-hidden {
  display: none;
}

.video-hidden {
  display: none;
}

.upload-actions {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.photo_desc{
    border: solid 0px;
    border-radius: 5px;
    background: #fff;
    font-size: 14px;
    font-family: 'Raleway';
    font-style: normal;
}

.video-actions {
  margin-top: 10px;
}

.rates {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    margin: 20px 0;
}
@media screen and (max-width: 768px) {
    .model-category{
        text-align: center;
    }
    .form-switch{
        text-align: center;
    }
    .rate-row {
        display: flex;
        flex-direction: column;
    }
    .rate-inputs {
        display: flex;
        flex-direction: column;
    }
}
.label-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  display: block;
}
.rate-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.rate-inputs {
  display: flex;
  gap: 10px;
  flex: 1;
}
.input-textx {
  padding: 8px;
  width: 100%;
}
.btn-add, .btn-remove, .btn-user-login {
    margin-top: 10px;
    color: #D33E74;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
}

.label-title{
    font-family: 'Raleway';
    font-weight: bold;
    font-size: 14px;
    color: #fff;
    background: #0A070F;
    border-radius: 10px;
    padding: 0.3rem;
}

.checkbox-group {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.checkbox-group label {
  font-size: 14px;
  color: #D33E74;
}
.btn-user-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 5px;
    background: #D33E74;
    border-radius: 50px;
    color: #fff;
    width: 150px;
    height: 40px;
}

@media screen and (max-width: 768px) {
  .wallet-hero {
    flex-direction: column;
  }

  .wallet-summary {
    min-width: 0;
    width: 100%;
  }

  .wallet-actions {
    width: 100%;
  }

  .wallet-btn {
    width: 100%;
  }

  .wallet-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .wallet-table .table > :not(caption) > * > * {
    padding: 0.8rem 0.75rem;
  }
}

.label {
  display: block;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.bio-tab{
    margin-top: 20px;
}
.nav-link{
    color: #D33E74;
}
.nav-tabs{
  border-bottom: 0px solid #111112;
}
 .nav-tabs .nav-link {
    cursor: pointer;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
 }

.nav-tabs .nav-link.active {
    background-color: #D33E74;
    color: white;
    border-radius: 0.25rem;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
}

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }

.tab-content{
    background: #111112 !important;
    color: #fff !important;
    width: 100%;
    div p {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
    }
}
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }

  .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 580px;
      height: 480px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: url(../assets/modal_bg.png) no-repeat fixed center, #0A070F;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    .welcome {
        margin-top: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

}
.modal-container{
    display: flex;
    flex-direction: row;
}
.login-modal-box {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0 solid;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
  }

  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    width: 100%;
    
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo {
    text-align: center;
    margin-top: -10px;
  }
  .modal-logo > img {
    width: 100px;
    
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 10px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 0px;

}

@media screen and (max-width: 768px) {

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 90%;
      height: 490px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
  }
  .modal-container{
    display: flex;
    flex-direction: row;
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: block;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo > img {
    width: 90px;
    text-align: center;
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 17px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 20px;

}

.terms {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    text-align: center;
    color: #FFFFFF;

    span {
        color: #D33E74;
    }
}

}
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }


     .profile-interest2{
         
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .interests2{
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 2px 8px;
             width: auto;
             height: 29px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 50px;
             color: #767475;
             font-size: 10px;
             margin: 4px;
 
         }
 
         .interests-info2 {
             display: flex;
             flex-direction: row;
             //padding: 0rem 3rem 5rem 1rem;
         }
     }
     .profile-relationship-goal2 {
         margin-top: -150px !important;
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .relationship-goal2 {
             display: flex;
             flex-direction: row;
             padding: 2px;
             width: 70%;
             height: auto;
             background: rgba(255, 214, 0, 0.1);
             border-radius: 61px;
             color: #FFD600;
             font-size: 10px;
             margin: 20px;
             text-align: left;
         }
 
     }
     .btn-unmatch-report2 {
         display: flex;
         flex-direction: row;
         align-items: center;
         .btn-unmatch2 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #D33E74;
             margin: 20px;
             cursor: pointer;
         }
         .btn-unmatch3 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #b1acae;
             margin: 20px;
             cursor: pointer;
         }
         .btn-report2 {
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #2D2D2D;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #767475;
             margin-right: 10px;
             cursor: pointer;
         }
     }
}
.content-fluid {
    background: transparent;
}
.container {
    margin-top: 80px;
    width: 100%;
    min-height: 80vh;
}
.profile-container{
    display: flex;
    flex-direction: row;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    width: 100%;

    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
        display: flex;
        flex-direction: column;
        justify-content: left;
        margin-top: 30px;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            text-align: left;
            color: #FFFFFF;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            text-align: left;
            color: #FFFFFF;
        }        
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-weight: 650;
    
        .btn-trial{
            background: #FFD600;
            border: solid 0;
            color: #000;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        font-family: 'Raleway';
        font-weight: 650;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
        .btn-boost{
            background: green;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
            color: #ddd;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            font-size: 11px;
            color: #ddd;
            a{
                color: green;
                text-decoration: none;
            }
        }

        .btn-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 70px;
        height: 30px;
        background: #007BFF;
        border: 0px solid;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
        
    }
    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
 .profile-picture{
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-right: 10px;
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    .btn-edit {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 18px;
        width: 120px;
        height: 40px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
    width: 100%;
 }
 .user-interests{
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* spacing between buttons */
 }

 .btn-chips {
  padding: 8px 16px;
  border: none;
  background-color: #eee;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background-color 0.3s;
}

.btn-chips:hover {
  background-color: #ddd;
}

 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
 }
 .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 .profile-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .column1{
    width: 400px;
    margin: 10px;
 }
 .button-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }

 .input-text-state {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .birthday{
    display: flex;
    flex-direction: row;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 114px;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {
    .container{
        margin-top: 100px;
        padding: 0px 0px 0px 0px !important;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .profile-image {
        display: flex;
        flex-direction: column;
        align-items: center;

        .img-profile {
            width: 30%;
            height: 30%;

        }
        .profile-info {
            padding: 0 0 0 0px;
           
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{
        margin-top: 10px;
        margin-bottom: 20px;
    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 100px;
            height: 35px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .mobile-line{
        color: #767475;
        width: 100%;
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-size: 12px;
        button{
            box-sizing: border-box;
            width: auto;
            height: 20px;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        .btn-trial{
            background: #FFD600 !important;
            width: auto !important;
            height: auto !important;
            font-size: 10px !important;
            padding: 4px !important;
            border-radius: 10px !important;
            border: solid 0;
            color: #000;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 10px;
            height: auto;
        }
        .btn-boost{
            border: solid 0;
            width: auto !important;
            height: auto !important;
            font-size: 10px !important;
            border-radius: 10px !important;
            padding: 0.4rem !important;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            text-decoration: none;
            color: #ddd;;
            width: 40% !important;
            height: auto !important;
            font-size: 10px !important;

        }

        .btn-chat {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 4px 2px !important;
            width: 70px !important;
            height: 35px;
            background: #007BFF;
            border: 0px solid;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        
    }
 .edit-profile-top {
  margin-left: 0px;
 }

 .profile-content{
    display: flex;
    flex-direction: column;
 }
 .column1{
    width: 100%;
    margin: 0px;
 }
 .user-interests{
   
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;

    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #fff;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>
